import { useFormatDecimals, useTranslation } from "@bounce/i18n"
import { useReviewCount } from "@bounce/reviews"

import { StoreCardTag } from "./StoreCardTag"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import StarIcon from "@bounce/assets/icons/Star-filled.svg"

type StoreCardRatingProps = {
  store: Pick<NearbyStorageSpot, "rating" | "reviewCount">
}

export const StoreCardRating = ({ store }: StoreCardRatingProps) => {
  const { t } = useTranslation()
  const reviewCount = useReviewCount({ store, truncate: false })
  const formatDecimals = useFormatDecimals({ minDecimalPlaces: 1, maxDecimalPlaces: 2 })

  return (
    <StoreCardTag
      bgColor={!!store.rating ? "neutral" : "purple"}
      icon={!!store.rating ? <StarIcon /> : undefined}
      text={!!store.rating ? `${formatDecimals(store.rating)} (${reviewCount})` : t("cmp.storeRating.new", "NEW")}
    />
  )
}
